import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Scroll } from '@shared/services/scroll.service';

@Component({
    selector: 'app-show-more',
    template: `
        <egov-show-more #showMore [expanded]="!!disabled || undefined">
            <ng-content></ng-content>
        </egov-show-more>
        <div class="button-clip" [class.collapse]="showMore?.expanded">
            <app-icon-button
                *ngIf="!disabled && showMore?.clipped"
                class="view-all-button grey"
                (click)="!showMore.expanded ? showMore.expand() : repositionScroll(showMore.collapse())"
            >
                {{ !showMore?.expanded ? "more_horiz" : "unfold_less" }}
            </app-icon-button>
        </div>
    `,
    styleUrls: ['./show-more.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowMoreComponent
{
    constructor
    (
        // Dependencies

        private readonly scroll: Scroll
    )
    {}

    // Customizations

    @Input() protected disabled = false;


    // Scroll

    protected repositionScroll(offset: number)
    {
        const position = this.scroll.get();
        this.scroll.reasonsToIgnoreScrollEvents.add('show-more-fold');
        this.scroll.set([position[0], position[1] - offset]);
        requestAnimationFrame(() => this.scroll.reasonsToIgnoreScrollEvents.delete('show-more-fold'));
    }
}
